module.exports = __webpack_public_path__ + "static/water_steamline-668da4ffd47fec811f0938a2d8405e7f.jpg";